var map = {
	"./mountain-badge--dark.svg": 907,
	"./mountain-badge--light.svg": 908,
	"./surf-badge--dark.svg": 909,
	"./surf-badge--light.svg": 910,
	"./tide-badge--dark.svg": 911,
	"./tide-badge--light.svg": 912,
	"./weather-badge--dark.svg": 913,
	"./weather-badge--light.svg": 914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 906;